
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/guide/[id]/wengine/[weaponId]",
      function () {
        return require("private-next-pages/game/guide/[id]/wengine/[weaponId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game/guide/[id]/wengine/[weaponId]"])
      });
    }
  